export const pickBy = (obj: any, keys: any) =>
  Object.keys(obj)
    .filter(k => keys.includes(k))
    .reduce((res, k) => Object.assign(res, {[k]: obj[k]}), {});

/**
 * Remove an element from an object
 * @param {string} key
 * @param {any} obj
 * @returns object
 */
export const omit = (key: string, obj: any) => {
  // eslint-disable-next-line
  const { [key]: omitted, ...rest } = obj;
  return rest;
};

export const pickNonEmptyKeys = (obj: any) => {
  return Object.keys(obj).reduce((acc: any, key) => {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};

export const isJSONString = (str: string) => {
  if (typeof str !== 'string') return false;
  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null;
  } catch (e) {
    return false;
  }
};
